import * as Sentry from '@sentry/react';

const dsn = import.meta.env.VITE_SENTRY_DSN?.trim() ?? '';

/** Inicializa Sentry se houver DSN. Sem DSN o app sobe normalmente. */
export function initSentry(): void {
  if (!dsn) {
    return;
  }
  Sentry.init({
    dsn,
    environment:
      import.meta.env.VITE_SENTRY_ENVIRONMENT?.trim() || import.meta.env.MODE,
    release: import.meta.env.VITE_APP_VERSION
      ? `momy-web-escola@${import.meta.env.VITE_APP_VERSION}`
      : undefined,
    sendDefaultPii: false,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: import.meta.env.PROD ? 0.2 : 1.0,
  });
}

export function setSentryUser(user: { idUsuario: number; codigoCliente?: number } | null): void {
  if (!dsn) return;
  if (!user) {
    Sentry.setUser(null);
    return;
  }
  Sentry.setUser({
    id: String(user.idUsuario),
  });
  if (user.codigoCliente != null) {
    Sentry.setTag('codigoCliente', String(user.codigoCliente));
  }
}

export { Sentry };
